import { GenericEmail } from './Generic';
export default GenericEmail;
